import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DynamicWorkflowStep  {
    _originalTypeClassName = "zERP.BO.DynamicWorkflowStep";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DynamicWorkflowStep.translate = translateService;
}
this.Id = null;
this.IsAccepted = false;
this.DateCreated = null;
this.DateAccepted = null;
this.Comments = null;
this.NextStatus = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsAccepted:any;
DateCreated:any;
DateAccepted:any;
Comments:any;
NextStatus:any;
Owner:any;
Department:any;
Creator:any;
Previous:any;
Next:any;
Task:any;
static setOwner = ($this, value) => {
var oldValue = $this.Owner;
$this.Owner = value;
if (value != null) {
}
}
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setCreator = ($this, value) => {
var oldValue = $this.Creator;
$this.Creator = value;
if (value != null) {
}
}
static setPrevious = ($this, value) => {
var oldValue = $this.Previous;
$this.Previous = value;
if (value != null) {
if (oldValue != null && oldValue.Next != null) { oldValue.Next = null; }
if ($this.Previous.Next !== $this) {
Domain.DynamicWorkflowStep.setNext(value, $this);
}
}
}
static setNext = ($this, value) => {
var oldValue = $this.Next;
$this.Next = value;
if (value != null) {
if (oldValue != null && oldValue.Previous != null) { oldValue.Previous = null; }
if ($this.Next.Previous !== $this) {
Domain.DynamicWorkflowStep.setPrevious(value, $this);
}
}
}
static setTask = ($this, value) => {
var oldValue = $this.Task;
$this.Task = value;
if (value != null) {
}
}

static GotoNextStep(status: any,department: any,owner: any,prevStep: any): any{let step = new Domain.DynamicWorkflowStep();
if (department != null && !(Domain.Department.IsNew(department))) {Domain.DynamicWorkflowStep.setDepartment(step, department);}
Domain.DynamicWorkflowStep.setOwner(step, owner);
step.DateCreated = moment().toDate();
Domain.DynamicWorkflowStep.setCreator(step, Domain.UserAccount.GetActive());
step.IsAccepted = false;
step.NextStatus = status + "";
if (prevStep != null) {Domain.DynamicWorkflowStep.setNext(prevStep, step);}
return step;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}